import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Heading,
  Stack,
  StackDivider,
  Box,
  Text,
  Image,
  Divider,
  ButtonGroup,
  Button,
  Wrap,
  Center,
  Flex,
  Spacer,
  IconButton,
  useBreakpointValue,
  HStack,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { transformData, findCategoryById } from '../util.js';
import { Rating } from './Rating.js';
import { UserBanner } from './User.js';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import ReactMarkdown from 'react-markdown';
import MD from './MD';
import React from 'react';
import {} from '@chakra-ui/react';
// Here we have used react-icons package for the icons
import { BiLeftArrowAlt, BiRightArrowAlt } from 'react-icons/bi';
// And react-slick as our Carousel Lib
import Slider from 'react-slick';
import { cans } from '../icblast.js';

import Breadcrumb from './Breadcrumb';
import { Link as RouterLink } from 'react-router-dom';

export function SingleService({ categories }) {
  let { id } = useParams();

  let [service, setService] = useState(false);
  useEffect(() => {
    (async () => {
      let s = await cans.qgig.get_service(parseInt(id, 10));

      s.gallery = s.gallery.split('\n');

      setService(s);
    })();
  }, []);

  if (!service) return null;
  if (!categories.length) return null;
  const category = findCategoryById(categories, service.category_id);

  return (
    <Center>
      <Stack w="800px">
        <Breadcrumb
          path={[{ name: category.name, to: '/category/' + category.id }]}
        />
        <ServiceCard {...service} />
      </Stack>
    </Center>
  );
}

function ServiceCard({
  id,
  title,
  description,
  price,
  image_url,
  rating,
  total_ratings,
  completed_count,
  user_id,
  user_img,
  user_name,
  user_rating,
  user_total_ratings,
  avg_completion_time,
  user_about,
  gallery,
}) {
  if (!id) return null;
  return (
    <Box>
      <Stack mt="3" spacing="3" m="1">
        <Heading size="md" textAlign={'left'} mt="15px">
          {title}
        </Heading>
        <Carousel cards={gallery} />

        <Flex>
          <Rating value={rating} total={total_ratings} />

          <Spacer />
          <Stack align="baseline" mt="0" spacing="0">
            <Box fontSize="12px" color="gray.400">
              {completed_count} successful gigs with average time of{' '}
              {moment.duration(avg_completion_time, 'seconds').humanize()}
            </Box>
          </Stack>
        </Flex>
        <UserBanner
          {...{
            user_id,
            user_img,
            user_name,
            user_rating,
            user_total_ratings,
          }}
          style={{ borderRadius: '25px 25px 25px 25px' }}
        />
        <Box textAlign="left" pt="20px" pb="20px">
          <ReactMarkdown components={MD} children={description} skipHtml />
        </Box>
      </Stack>

      <Box p="1" pb="4">
        <Flex>
          <Spacer />
          <ButtonGroup>
            <Button variant="solid" colorScheme="green" size="sm">
              Buy for {(price / 1000).toFixed(2)} GIG
            </Button>
          </ButtonGroup>
        </Flex>
      </Box>

      <Stack border="1px" borderRadius="md" borderColor="gray.700" p="3">
        <RouterLink to={'/user/' + user_id}>
          <HStack>
            <Image
              w={'50px'}
              h={'50px'}
              src={user_img}
              alt={user_name}
              borderRadius="20px"
            />
            <Stack>
              <Box>{user_name} </Box>
              <Rating value={user_rating} total={user_total_ratings} />
            </Stack>
          </HStack>
        </RouterLink>
        <Box textAlign="left" fontSize="14px" pt="20px" pb="20px">
          {user_about}
        </Box>
      </Stack>
    </Box>
  );
}

// Settings for the slider
const settings = {
  dots: true,
  arrows: false,
  fade: true,
  infinite: true,
  autoplay: true,
  speed: 500,
  autoplaySpeed: 5000,
  slidesToShow: 1,
  slidesToScroll: 1,
};

export function Carousel({ cards }) {
  // As we have used custom buttons, we need a reference variable to
  // change the state
  const [slider, setSlider] = useState(false); //(React.useState < Slider) | (null > null);

  // These are the breakpoints which changes the position of the
  // buttons as the screen size changes
  const top = useBreakpointValue({ base: '90%', md: '50%' });
  const side = useBreakpointValue({ base: '30%', md: '10px' });

  // These are the images used in the slide
  //   const cards = [
  //     'https://images.unsplash.com/photo-1612852098516-55d01c75769a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDR8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=900&q=60',
  //     'https://images.unsplash.com/photo-1627875764093-315831ac12f7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDJ8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=900&q=60',
  //     'https://images.unsplash.com/photo-1571432248690-7fd6980a1ae2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDl8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=900&q=60',
  //   ];

  return (
    <Box
      position={'relative'}
      height={'500px'}
      width={'full'}
      overflow={'hidden'}
    >
      {/* CSS files for react-slick */}
      <link
        rel="stylesheet"
        type="text/css"
        charSet="UTF-8"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
      />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
      />
      {/* Left Icon */}
      <IconButton
        aria-label="left-arrow"
        colorScheme="messenger"
        borderRadius="full"
        position="absolute"
        left={side}
        top={top}
        transform={'translate(0%, -50%)'}
        zIndex={2}
        onClick={() => slider?.slickPrev()}
      >
        <BiLeftArrowAlt />
      </IconButton>
      {/* Right Icon */}
      <IconButton
        aria-label="right-arrow"
        colorScheme="messenger"
        borderRadius="full"
        position="absolute"
        right={side}
        top={top}
        transform={'translate(0%, -50%)'}
        zIndex={2}
        onClick={() => slider?.slickNext()}
      >
        <BiRightArrowAlt />
      </IconButton>
      {/* Slider */}
      <Slider {...settings} ref={slider => setSlider(slider)}>
        {cards.map((url, index) => (
          <Box
            key={index}
            height={'500px'}
            position="relative"
            backgroundPosition="center center"
            backgroundRepeat="no-repeat"
            backgroundSize="contain"
            backgroundImage={`url(${url})`}
          />
        ))}
      </Slider>
    </Box>
  );
}
